export default __webpack_public_path__ + "static/media/parent-department.0078c110.svg";